import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from './LoadingSpinner';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Show loading spinner while authentication state is being determined
  if (loading) {
    return <LoadingSpinner message="Loading..." />;
  }

  // If not authenticated, save destination and redirect to login
  if (!user) {
    // Check if this is an explicit logout - don't save redirect or show auth message
    const explicitLogout = sessionStorage.getItem('explicitLogout');

    if (!explicitLogout) {
      // Only set redirect and auth message for unauthorized access attempts
      const redirectPath = location.pathname + location.search + location.hash;
      sessionStorage.setItem('redirectAfterLogin', redirectPath);
      sessionStorage.setItem('authMessage', 'Please authenticate to access the page.');
    }

    return <Navigate to="/signin" replace />;
  }

  // User is authenticated, render the protected content
  return children;
};

export default ProtectedRoute;
